/* Harps & Seb two-tier cart rewards bar.
 *
 * Renders progress toward two milestones:
 *   tier 1 - free shipping
 *   tier 2 - free gift product
 *
 * This file NEVER prices anything. The gift is zeroed by an automatic
 * "Buy X get Y" discount in Shopify admin. All this does is keep the bar in
 * sync with the cart, let the customer claim the gift once they qualify, and
 * pull the gift back out if the cart drops below the threshold (so nobody is
 * ever charged for something the site called free).
 *
 * Depends on jQuery (loaded in layout/theme.liquid) and, where available,
 * the theme's own ShopifyAPI + delegated cart handlers in assets/wpbingo.js.
 */
(function ($) {
  'use strict';

  if (!$) return;

  var GIFT_PROPERTY = '_free_gift';
  var REOPEN_KEY = 'hsRewardsReopenDrawer';

  var busy = false;

  // Highest tier unlocked at last render. null until the first render, so we
  // never fire confetti just for loading a page that already qualifies.
  var lastLevel = null;

  // Set once the gift proves unaddable or uncharged-for, to stop add/remove loops.
  var giftBlocked = false;

  function bars() {
    return $('[data-hs-rewards]');
  }

  function money(cents) {
    if (window.wpbingo && wpbingo.Currency && typeof wpbingo.Currency.formatMoney === 'function') {
      var format = (window.wpbingo.strings && wpbingo.strings.moneyFormat) || '${{amount}}';
      return wpbingo.Currency.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function isGift(item) {
    return !!(item && item.properties && item.properties[GIFT_PROPERTY]);
  }

  /* Sum of everything the customer actually paid for. Uses original_line_price
   * and skips the gift so a $0 gift can never push the cart over its own
   * threshold and lock itself in. */
  function qualifyingSubtotal(cart) {
    var total = 0;
    $.each(cart.items || [], function (_, item) {
      if (!isGift(item)) total += item.original_line_price;
    });
    return total;
  }

  function findGiftLine(cart) {
    var found = null;
    $.each(cart.items || [], function (i, item) {
      if (!found && isGift(item)) found = { line: i + 1, item: item };
    });
    return found;
  }

  /* The theme rebuilds its cart through ajaxCart.load() - a public function it
   * calls from every one of its own add-to-cart paths. Nothing in the theme
   * watches for cart mutations it did not make, so any add of ours has to ask
   * for the rebuild explicitly or the drawer keeps showing stale line items. */
  function rebuildThemeCart() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
      return;
    }
    reloadKeepingDrawer();
  }

  function reloadKeepingDrawer() {
    try {
      if ($('body').hasClass('drawer--open')) {
        window.sessionStorage.setItem(REOPEN_KEY, '1');
      }
    } catch (e) {
      /* private browsing - the reload still happens, the drawer just closes */
    }
    window.location.reload();
  }

  function reopenDrawerIfFlagged() {
    var flagged;
    try {
      flagged = window.sessionStorage.getItem(REOPEN_KEY);
      if (flagged) window.sessionStorage.removeItem(REOPEN_KEY);
    } catch (e) {
      return;
    }
    if (flagged) $('body').trigger('drawer.open');
  }

  /* ------------------------------------------------------------------ */
  /* render                                                              */
  /* ------------------------------------------------------------------ */

  /* The drawer lays its header out with position:absolute and then starts the
   * item list at a hardcoded `top: 160px` (assets/site.scss.liquid). That number
   * was tuned for the old one-line shipping bar; a two-tier bar is taller and
   * would sit on top of the cart items. Measure the header and drive the offset
   * from the real height instead - it also absorbs the claim button appearing,
   * a message wrapping to two lines, and the smaller mobile padding. */
  function syncDrawerOffset() {
    var $header = $('.js-drawer .drawer__header');
    var $inner = $('.js-drawer .drawer__inner');
    if (!$header.length || !$inner.length) return;
    if (!$header.find('[data-hs-rewards]').length) return;

    var height = Math.ceil($header.outerHeight());
    if (height > 0) $inner.css('top', height + 'px');
  }

  function watchDrawerHeight() {
    var header = document.querySelector('.js-drawer .drawer__header');
    if (!header) return;

    if (typeof window.ResizeObserver === 'function') {
      new ResizeObserver(syncDrawerOffset).observe(header);
    }
    $(window).on('resize.hsRewards', syncDrawerOffset);
    // Webfonts land after first paint and change the measured height.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncDrawerOffset).catch(function () {});
    }
  }

  function render(cart) {
    var subtotal = qualifyingSubtotal(cart);
    var giftLine = findGiftLine(cart);

    bars().each(function () {
      var $bar = $(this);
      var tier1 = parseInt($bar.attr('data-tier1'), 10) || 0;
      var tier2 = parseInt($bar.attr('data-tier2'), 10) || 0;
      var twoTier = tier2 > tier1;
      var goal = twoTier ? tier2 : tier1;
      if (!goal) return;

      var tier1Hit = subtotal >= tier1;
      var tier2Hit = twoTier && subtotal >= tier2;

      var percent = Math.min(100, (subtotal / goal) * 100);
      $bar.find('[data-hs-rewards-fill]').css('width', percent + '%');

      $bar.find('[data-hs-rewards-notch="1"]').toggleClass('is-hit', tier1Hit);
      $bar.find('[data-hs-rewards-notch="2"]').toggleClass('is-hit', tier2Hit);

      $bar.find('[data-hs-rewards-tier="1"]').toggleClass('is-unlocked', tier1Hit);
      $bar.find('[data-hs-rewards-tier="2"]').toggleClass('is-unlocked', tier2Hit);

      var template;
      var remaining = 0;
      if (!tier1Hit) {
        remaining = tier1 - subtotal;
        template = $bar.attr('data-msg-tier1');
      } else if (twoTier && !tier2Hit) {
        remaining = tier2 - subtotal;
        template = $bar.attr('data-msg-tier2');
      } else {
        template = twoTier ? $bar.attr('data-msg-complete') : $bar.attr('data-msg-shipping-only');
      }
      $bar
        .find('[data-hs-rewards-message]')
        .html(String(template || '').split('[amount]').join(money(remaining)));

    });

    renderUpsell(cart, subtotal);
    markGiftLine(giftLine);
    syncDrawerOffset();
    celebrate(subtotal);
    renderGiftCard(subtotal, giftLine);
    manageGift(subtotal, giftLine);
  }

  /* The bar this replaced owned the theme's confetti moment. Keep it, but fire
   * it only on the transition into a tier - not on every re-render. */
  function celebrate(subtotal) {
    var level = 0;
    var enabled = false;

    bars().each(function () {
      var $bar = $(this);
      if ($bar.attr('data-celebrate') === 'true') enabled = true;
      var tier1 = parseInt($bar.attr('data-tier1'), 10) || 0;
      var tier2 = parseInt($bar.attr('data-tier2'), 10) || 0;
      if (tier2 > tier1 && subtotal >= tier2) level = Math.max(level, 2);
      else if (tier1 && subtotal >= tier1) level = Math.max(level, 1);
    });

    var crossed = lastLevel !== null && level > lastLevel;
    lastLevel = level;

    if (!crossed || !enabled) return;
    if (typeof window.confettiLoop !== 'function') return;

    $('#fire_work').removeClass('hide');
    window.confettiLoop();
    window.setTimeout(function () {
      $('#fire_work').addClass('hide');
    }, 4000);
  }

  /* ------------------------------------------------------------------ */
  /* gift add / remove                                                   */
  /* ------------------------------------------------------------------ */

  function renderGiftCard(subtotal, giftLine) {
    var $cards = $('[data-hs-gift-card]');
    if (!$cards.length) return;

    var $bar = bars().first();
    var tier2 = parseInt($bar.attr('data-tier2'), 10) || 0;
    var unlocked = tier2 > 0 && subtotal >= tier2;

    var text;
    if (unlocked) {
      text = giftLine ? $bar.attr('data-gift-unlocked') || '' : '';
    } else {
      text = String($bar.attr('data-gift-locked') || '')
        .split('[amount]')
        .join(money(Math.max(0, tier2 - subtotal)));
    }

    $cards.toggleClass('is-unlocked', unlocked);
    $cards.find('[data-hs-gift-status]').text(text).prop('hidden', !text);
  }

  /* One place that decides what the gift line should be, run after every cart
   * read. The gift is added automatically on crossing the threshold rather
   * than offered as a button: it is a reward, and asking the shopper to claim
   * it makes it read like one more thing to buy. */
  function manageGift(subtotal, giftLine) {
    if (busy) return;

    var $bar = bars().first();
    if (!$bar.length) return;

    var variantId = $bar.attr('data-gift-variant');
    var tier2 = parseInt($bar.attr('data-tier2'), 10) || 0;

    /* The gift is in the cart but is not free, so the Buy X get Y discount is
     * not applying. Pull it straight back out: a charge on a line the site
     * calls free is worse than no gift at all. Once seen, stop adding it for
     * the rest of the session rather than looping add/remove. */
    if (giftLine && giftLine.item.final_line_price > 0) {
      giftBlocked = true;
      changeGiftLine(giftLine.line, 0);
      return;
    }

    // Tier switched off, or the cart dropped back under the threshold.
    if (giftLine && (!tier2 || subtotal < tier2)) {
      changeGiftLine(giftLine.line, 0);
      return;
    }

    if (giftLine && giftLine.item.quantity > 1) {
      changeGiftLine(giftLine.line, 1);
      return;
    }

    if (!giftLine && variantId && tier2 && subtotal >= tier2 && !giftBlocked) {
      addGift(variantId);
    }
  }

  function addGift(variantId) {
    busy = true;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: 1,
        properties: { _free_gift: 'true' }
      }
    })
      .done(function () {
        busy = false;
        rebuildThemeCart();
      })
      .fail(function () {
        // Out of stock or otherwise unaddable - do not keep retrying.
        giftBlocked = true;
        busy = false;
      });
  }

  function changeGiftLine(line, quantity) {
    busy = true;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: { line: line, quantity: quantity }
    })
      .done(function () {
        busy = false;
        rebuildThemeCart();
      })
      .fail(function () {
        busy = false;
      });
  }

  /* ------------------------------------------------------------------ */
  /* upsell                                                              */
  /* ------------------------------------------------------------------ */

  /* Cheapest single product that would carry the cart past `gap`. Cheapest
   * rather than closest, because overshooting the threshold by a dollar on a
   * cheap item beats hitting it exactly with an expensive one - the customer
   * is trying to unlock a reward, not spend a target. */
  function pickKeyItem($items, gap) {
    var best = null;
    var bestPrice = Infinity;

    $items.each(function () {
      var price = parseInt($(this).attr('data-price'), 10);
      if (!price || price < gap) return;
      if (price < bestPrice) {
        bestPrice = price;
        best = this;
      }
    });

    return best;
  }

  /* The theme's handlebars cart data does not carry line item properties, so
   * the gift line cannot be flagged inside the template. Mark it here instead,
   * after the theme has rendered: badge it, and lock its quantity to 1.
   *
   * The quantity lock is not cosmetic. The Buy X get Y discount is capped at
   * one use per order, so a customer who bumps the gift to 3 pays full price
   * for the other two - a charge on a line the site calls free. */
  function markGiftLine(giftLine) {
    var label = '';
    var $bar = bars().first();
    if ($bar.length) label = $bar.attr('data-gift-line-label') || '';

    $('.ajaxcart__product').removeClass('hs-gift-line');
    $('.hs-gift-flag').remove();
    if (!giftLine) return;

    var $line = $('.ajaxcart__product[data-line="' + giftLine.line + '"]');
    if (!$line.length) return;

    $line.addClass('hs-gift-line');
    if (label) {
      $line
        .find('.ajaxcart__product-name-wrapper')
        .first()
        .append($('<span class="hs-gift-flag"></span>').text(label));
    }

    if (giftLine.item.quantity > 1 && !busy) {
      busy = true;
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: { line: giftLine.line, quantity: 1 }
      })
        .done(function () {
          busy = false;
          rebuildThemeCart();
        })
        .fail(function () {
          busy = false;
        });
    }
  }

  function renderUpsell(cart, subtotal) {
    var $upsell = $('[data-hs-upsell]');
    if (!$upsell.length) return;

    var inCart = {};
    $.each(cart.items || [], function (_, item) {
      inCart[item.variant_id] = true;
    });

    // Next threshold the cart has not reached yet, and which tier it belongs to.
    var gap = 0;
    var gapTier = 0;
    bars().each(function () {
      var $bar = $(this);
      var tier1 = parseInt($bar.attr('data-tier1'), 10) || 0;
      var tier2 = parseInt($bar.attr('data-tier2'), 10) || 0;
      if (tier1 && subtotal < tier1) {
        gap = tier1 - subtotal;
        gapTier = 1;
      } else if (tier2 > tier1 && subtotal < tier2) {
        gap = tier2 - subtotal;
        gapTier = 2;
      }
    });

    var $visible = $();
    $upsell.find('[data-hs-upsell-item]').each(function () {
      var $item = $(this);
      var hide = !!inCart[$item.attr('data-variant-id')];
      $item.prop('hidden', hide).removeClass('is-key');
      $item.find('[data-hs-upsell-badge]').prop('hidden', true);
      if (!hide) $visible = $visible.add($item);
    });

    // Nothing left to suggest once every product is already in the cart.
    $upsell.prop('hidden', $visible.length === 0);

    var key = gap > 0 ? pickKeyItem($visible, gap) : null;
    if (!key) return;

    /* Name the reward this product unlocks. "Unlocks your reward" sitting on a
     * product the shopper buys reads as though that product IS the reward,
     * which is exactly the thing the free gift is not. */
    var rewardName = $('[data-hs-rewards-tier="' + gapTier + '"] .hs-rewards__tier-name')
      .first()
      .text()
      .trim();
    var badge = String($upsell.attr('data-badge') || '')
      .split('[reward]')
      .join(rewardName);

    var $key = $(key);
    $key.addClass('is-key');
    $key
      .find('[data-hs-upsell-badge]')
      .text(badge)
      .prop('hidden', !badge);

    // Promote it so the customer sees it without scrolling the strip.
    $key.prependTo($key.parent());
  }

  function addUpsell($btn, variantId) {
    if (busy || !variantId) return;
    busy = true;
    $btn.attr('disabled', 'disabled');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { id: variantId, quantity: 1 }
    })
      .done(function () {
        busy = false;
        rebuildThemeCart();
      })
      .fail(function () {
        busy = false;
        $btn.removeAttr('disabled');
      });
  }

  /* ------------------------------------------------------------------ */
  /* wiring                                                              */
  /* ------------------------------------------------------------------ */

  /* Collapses the bursts that arrive when one cart change produces several
   * signals (our ajaxComplete hook, then the theme's rebuild event). */
  var refreshTimer = null;
  function refresh() {
    if (!bars().length && !$('[data-hs-upsell]').length) return;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      $.getJSON('/cart.js', render);
    }, 60);
  }

  $(function () {
    if (!bars().length && !$('[data-hs-upsell]').length) return;

    $(document).on('click', '[data-hs-upsell-add]', function (e) {
      e.preventDefault();
      var $btn = $(this);
      addUpsell($btn, $btn.attr('data-variant-id'));
    });

    reopenDrawerIfFlagged();
    syncDrawerOffset();
    watchDrawerHeight();
    refresh();

    // Every cart mutation in this theme goes through jQuery ajax to
    // /cart/*.js, so one hook catches add, change, update and clear.
    $(document).ajaxComplete(function (event, xhr, options) {
      var url = (options && options.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        refresh();
      }
    });

    /* The theme replaces the drawer's markup wholesale on every rebuild, which
     * throws away the gift badge and the upsell's ordering. cartCallback fires
     * this event at the end of each rebuild, so it is the signal to reapply
     * them - including after adds the theme made on its own. */
    $('body').on('drawer.footer', refresh);
  });
})(window.jQuery);
